import React, { FC } from 'react'
import { TextBox, TextBoxProps } from '@ds/ui'

interface FreeformProps extends TextBoxProps {
  /** The text to display in the input. */
  value: string
  /** Fired when user updates the input text. Will not fire for disallowed characters. */
  onChangeText: (
    value: string,
    event: React.ChangeEvent<HTMLInputElement>
  ) => void
}

/**
 * Renders an un-formatted phone number input.
 *
 * @param props
 */
export const Freeform: FC<FreeformProps> = ({ onChangeText, ...restProps }) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value: eventValue } = event.target
    const cleanedInput = eventValue.replace(/[^ \d)(+-]/g, '')
    onChangeText(cleanedInput, event)
  }

  return <TextBox {...restProps} onChange={handleChange} />
}
